import styled from '@emotion/styled'
import { breakpoint, calcRem } from '../../../__styling'


export const AppDownloadImageSection = styled('div')({
    display: 'flex',
    position: 'relative',

    justifyContent: 'center',
    alignItems: 'end',

    width: '100%',
})

export const StyledAppDownloadImage = styled('img')({
    display: 'flex',
    position: 'relative',
    zIndex: 2,

    width: '100%',

    [breakpoint('sm')]: {
        width: calcRem(690),
        maxWidth: calcRem(690),
    },
})
